import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeReactContext} from 'lib/makeReactContext';

export type PlatformFlowchartFeatures = Map<ProcessFlowchartPlatformFeatureType, boolean>;

/** Context to provide platform flowchart features to child components */
export const PlatformFeaturesContext = makeReactContext<PlatformFlowchartFeatures | undefined>(
  () => undefined,
  'PlatformFeaturesContext'
);
